import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import MoonMark from "@/components/MoonMark";
import { MoonPhaseRow } from "@/components/Ornaments";
import DonateModal from "@/components/DonateModal";

const API = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const year = new Date().getFullYear();
  const [donateOpen, setDonateOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("donation") === "success" && params.get("session_id")) {
      fetch(`${API}/api/donations/status/${params.get("session_id")}`).catch(() => {});
      toast.success("Your offering is received — it will join the wall once approved.");
      window.history.replaceState({}, "", window.location.pathname);
    }
    const onOpenDonate = () => setDonateOpen(true);
    window.addEventListener("nox-open-donate", onOpenDonate);
    return () => window.removeEventListener("nox-open-donate", onOpenDonate);
  }, []);

  return (
    <footer className="relative border-t border-line bg-[#050507]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="flex flex-col items-center gap-8 text-center">
          <MoonMark className="h-12 w-12 text-gold" />
          <div>
            <p className="font-display text-2xl tracking-[0.35em] text-silver">NOX HARMONIA</p>
            <p className="mt-3 font-cormorant text-lg italic text-slate-500">Harmonies of the Night</p>
          </div>
          <MoonPhaseRow />
          <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-slate-500">
            <Link to="/" data-testid="footer-link-intro" className="transition-colors hover:text-gold">
              Intro
            </Link>
            <Link to="/commission" data-testid="footer-link-commission" className="transition-colors hover:text-gold">
              Commission
            </Link>
            <Link to="/portfolio" data-testid="footer-link-portfolio" className="transition-colors hover:text-gold">
              Portfolio
            </Link>
            <Link to="/services" data-testid="footer-link-services" className="transition-colors hover:text-gold">
              Services
            </Link>
            <a
              href="https://nox-harmonia.itch.io/"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-link-itch"
              className="transition-colors hover:text-gold"
            >
              itch.io
            </a>
            <button
              onClick={() => setDonateOpen(true)}
              data-testid="footer-support-btn"
              className="flex cursor-pointer items-center gap-2 transition-colors hover:text-gold"
            >
              <Heart className="h-3 w-3" />
              Support
            </button>
          </nav>
          <div className="hairline w-40" />
          <p className="font-jmono text-[10px] tracking-[0.25em] text-slate-600">
            © {year} PAUL ELLIOTT MESSIER · NOX HARMONIA · AAA CREDITS SHIPPED UNDER VOLT VMC FOR ELECTRONIC ARTS
          </p>
          <Link
            to="/admin"
            data-testid="footer-link-admin"
            className="text-[10px] uppercase tracking-[0.3em] text-slate-700 transition-colors hover:text-slate-500"
          >
            Site Admin
          </Link>
        </div>
      </div>
      {donateOpen && <DonateModal onClose={() => setDonateOpen(false)} />}
    </footer>
  );
};

export default Footer;
